(function () {
  'use strict';

  const ICONS = {
    generated: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="8" height="8" fill="currentColor"><path d="M6 0 7.35 4.65 12 6 7.35 7.35 6 12 4.65 7.35 0 6 4.65 4.65z"/></svg>',
    modified:  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width="8" height="8" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"><path d="M6 0 7.35 4.65 12 6 7.35 7.35 6 12 4.65 7.35 0 6 4.65 4.65z"/></svg>',
  };

  function detectType(alt) {
    const s = (alt || '').toLowerCase();
    if (s.includes('modella generata con ia')) return 'generated_model';
    if (s.includes('generata con ia') || s.includes('generato con ia')) return 'generated';
    if (s.includes('modificata con ia') || s.includes('modificato con ia')) return 'modified';
    return null;
  }

  function getLabels() {
    try {
      const el = document.getElementById('ai-pill-labels');
      return el ? JSON.parse(el.textContent) : {};
    } catch (_) { return {}; }
  }

  function updatePill(pill, pswp) {
    const alt = pswp.currSlide?.data?.alt || '';
    const type = detectType(alt);

    if (!type) { pill.hidden = true; return; }

    const baseType = type === 'generated_model' ? 'generated' : type;
    const labels = getLabels();
    const label = labels[type]
      || (type === 'generated_model' ? 'Modella IA' : type === 'generated' ? 'Generato con IA' : 'Modificato con IA');

    pill.querySelector('.ai-pill__icon').innerHTML = ICONS[baseType] || '';
    pill.querySelector('.ai-pill__label').textContent = label;
    pill.setAttribute('aria-label', label);
    pill.classList.remove('ai-pill--generated', 'ai-pill--modified');
    pill.classList.add('ai-pill--' + baseType);
    pill.hidden = false;
  }

  function attachToPswp(pswpEl, gallery) {
    const pill = document.createElement('div');
    pill.className = 'ai-pill ai-pill--top-right';
    pill.setAttribute('role', 'img');
    pill.hidden = true;

    const icon = document.createElement('span');
    icon.className = 'ai-pill__icon';
    icon.setAttribute('aria-hidden', 'true');
    pill.appendChild(icon);

    const label = document.createElement('span');
    label.className = 'ai-pill__label';
    pill.appendChild(label);

    pswpEl.appendChild(pill);

    let attempts = 0;
    const poll = setInterval(() => {
      const pswp = gallery.lightBox?.pswp;
      if (pswp?.currSlide || ++attempts > 60) {
        clearInterval(poll);
        if (!pswp) return;
        updatePill(pill, pswp);
        pswp.on('change', () => updatePill(pill, pswp));
      }
    }, 25);
  }

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1 || !node.classList?.contains('pswp')) continue;
        const gallery = document.querySelector('product-gallery');
        if (gallery) attachToPswp(node, gallery);
      }
    }
  }).observe(document.body, { childList: true });
})();
